import script from "./h5.vue?vue&type=script&setup=true&lang=js"
export * from "./h5.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__